import { useGetSupplierReportQuery } from '@/features/slice/report';
import { mapSupplierReportListToCsvExport } from '@/modules/reports/supplier/mapper';
import { jsonToCsv } from '@/utils/json-to-csv.util';

export const useSupplierReport = () => {
    const { data, isLoading, isError, isFetching, error } =
        useGetSupplierReportQuery({});

    const handleExportToPdf = () => {
        alert('Not implemented yet');
    };

    const handleExportToCSV = () => {
        jsonToCsv(
            mapSupplierReportListToCsvExport(data?.data ?? []),
            'customer_report.csv',
        );
    };
    return {
        handleExportToCSV,
        handleExportToPdf,

        data,
        isLoading,
        isError,
        isFetching,
        error,
    };
};
